import { UI_TEXT_RU } from '@uplink/ui';

/** Russian interface text. The shape is the contract: en.ts must provide every key. */
export const ru = {
  locale: 'ru-RU',
  ui: UI_TEXT_RU,
  common: {
    back: 'Назад',
    show: 'Показать',
    hide: 'Скрыть',
    copy: 'Копировать',
    copied: 'Скопировано',
    delete: 'Удалить',
    change: 'Изменить',
    cancel: 'Отмена',
    save: 'Сохранить',
    continue: 'Продолжить',
    done: 'Готово',
    all: 'Все',
    allN: (n: number) => `Все ${n}`,
    perMonth: 'в месяц',
    perYear: 'в год',
    from: (price: string) => `от ${price}`,
    topUpBy: (amount: string) => `Пополнить на ${amount}`,
    autoRenew: 'Автопродление',
    until: (date: string) => `до ${date}`,
  },
  errors: {
    fields: 'Проверьте заполненные поля',
    openInTelegram: 'Откройте приложение из Telegram',
    signedOut: 'Вы вышли из аккаунта. Обновите страницу и войдите снова',
    network: 'Не получилось связаться с сервером. Проверьте интернет и попробуйте ещё раз',
  },
  tabs: { home: 'Главная', domains: 'Домены', servers: 'Серверы', balance: 'Баланс', profile: 'Профиль' },

  home: {
    greeting: (name: string) => `Привет, ${name}`,
    payVia: (names: string[]) => `Криптой через ${names.join(' или ')}`,
    domain: 'Домен',
    domainFrom: (price: string) => `от ${price} в год`,
    domainHint: 'Поиск и регистрация',
    server: 'Сервер',
    serverFrom: (price: string) => `от ${price} в месяц`,
    serverHint: 'Облачные серверы',
    myServers: 'Серверы',
    myDomains: 'Домены',
    emptyTitle: 'Пока нет услуг',
    emptyText: 'Здесь появятся ваши серверы и домены: статус, IP, дата продления.',
  },

  trialVpn: {
    title: 'Пробный VPN',
    promo: '24 часа бесплатно',
    activePromo: 'Ключ уже готов',
    intro: 'Получите личный VLESS-ключ, подключитесь и проверьте скорость Uplink на своём устройстве.',
    terms: 'Один пробный период на аккаунт, до 2 устройств и 10 ГБ трафика.',
    issue: 'Получить ключ на 24 часа',
    key: 'Ваш VLESS-ключ',
    validUntil: (date: string) => `Работает до ${date}`,
    check: 'Подключиться и проверить VPN',
    expired: 'Пробный период завершён',
    expiredText: 'Бесплатный ключ уже был использован на этом аккаунте.',
  },

  sharedVpn: {
    shortTitle: 'VPN-доступ',
    from: (price: string) => `${price} в месяц`,
    title: 'VPN по подписке',
    intro: 'Готовый VPN-ключ без покупки и настройки сервера. Подключение занимает несколько минут.',
    key: 'Ваш VLESS-ключ',
    validUntil: (date: string) => `Оплачено до ${date}`,
    autoRenew: 'Автопродление',
    price: (price: string) => `${price} каждые 30 дней`,
    devices: 'До 2 устройств',
    traffic: '100 ГБ трафика на 30 дней',
    renewal: 'Автопродление можно отключить',
    ownTitle: 'Нужен отдельный сервер и личный IP?',
    ownText:
      'Создайте свой VPN со стабильным IP, собственной панелью и отдельными ключами для семьи или команды.',
    buy: (price: string) => `Купить VPN за ${price}`,
    preparing: 'Готовим ваш VPN-ключ',
    preparingText: 'Оплата удержана, повторно платить не нужно. Экран обновится после выдачи.',
  },

  domains: {
    title: 'Домены',
    searchPlaceholder: 'Найдите домен',
    zones: 'Зоны',
    popular: 'Популярные',
    all: 'Все',
    checking: 'Проверяем доступность…',
    nothingTitle: 'Ничего не нашли',
    nothingText: 'Попробуйте другое имя или зону.',
    results: 'Результаты',
    resultsFooter: 'Цена продления показана для каждой зоны. Премиум-домены оформляются через поддержку.',
    mine: 'Мои домены',
    expiredRenew: 'Срок истёк, продлите',
    registering: 'Регистрируется',
    autoRenewOn: 'автопродление',
    emptyTitle: 'Найдите свой домен',
    emptyText: 'Введите имя: проверим .com, .io, .xyz и другие зоны и покажем цену регистрации и продления.',
    aiRow: 'Подобрать имя с AI',
    aiRowText: 'По описанию проекта',
    aiLabel: 'О чём проект',
    aiPlaceholder: 'Кофейня в Казани с доставкой',
    aiHint: 'Пара слов о деле или идее, на любом языке',
    aiPick: 'Подобрать имена',
    aiAgain: 'Подобрать ещё',
    aiResults: 'Свободные имена',
    aiFooter: 'Имена предложил AI, свободность и цену проверили у регистратора.',
    aiNothingTitle: 'Свободных имён не нашлось',
    aiNothingText: 'Опишите проект чуть иначе или подробнее и попробуйте снова.',
  },

  checkout: {
    domain: 'Домен',
    firstYear: 'за первый год',
    renewal: (price: string) => `продление ${price} в год`,
    noRefund: 'Домены после регистрации не возвращаются.',
    owner: 'Владелец домена',
    ownerUplinkFooter:
      'Домен регистрируется на Uplink, а управляете им вы: здесь, в приложении. Перенести к другому регистратору можно через поддержку.',
    ownerUplinkSubtitle: 'Ваши данные регистратору не передаются',
    ownerIcann: 'Данные уходят регистратору (требование ICANN).',
    ownerIcannSaved: 'Данные уходят регистратору (требование ICANN). Сохраним их для следующих доменов.',
    firstName: 'Имя',
    lastName: 'Фамилия',
    email: 'Email',
    emailHint: 'Сюда придёт письмо подтверждения от реестра',
    phone: 'Телефон',
    country: 'Страна',
    countryHint: 'Код из двух букв',
    zip: 'Индекс',
    city: 'Город',
    street: 'Улица и дом',
    payment: 'Оплата',
    fromBalance: 'С баланса',
    buyFor: (price: string) => `Оформить за ${price}`,
    registered: 'Домен зарегистрирован на год. Продлим автоматически с баланса.',
    myDomains: 'Мои домены',
    registering: (domain: string) => `Регистрируем ${domain}`,
    manualReview:
      'Регистратор отвечает дольше обычного, заказ проверит оператор. Деньги зарезервированы, бот напишет о результате.',
    usuallyMinute: 'Обычно это занимает до минуты. Можно закрыть приложение: бот пришлёт сообщение.',
    refused: (domain: string) => `Регистратор отказал в регистрации ${domain}. Деньги вернулись на баланс.`,
    pickAnother: 'Выбрать другой домен',
  },

  domain: {
    renewal: 'Продление',
    autoFooter: 'Продлим с баланса за 7 дней до окончания. Бот напомнит за 30, 7 и 1 день.',
    manualFooter: 'Бот напомнит за 30, 7 и 1 день до окончания.',
    validUntil: 'Действует до',
    renewed: 'Продлено. Бот прислал подтверждение.',
    point: 'Сайт на сервере',
    pointFooter: 'Домен и www получат A-записи с IP сервера. Почта и остальные записи останутся как были.',
    pointTo: 'Направить',
    pointed: 'Направлен',
    pointDone: (server: string) => `Домен смотрит на ${server}. DNS обновится за несколько минут.`,
    renewFor: (price: string) => `Продлить на год за ${price}`,
    statusPending: 'Регистрируется',
    statusExpired: 'Истёк',
    statusExpiresIn: (days: number) => `Истекает через ${days} ${plural(days, 'день', 'дня', 'дней')}`,
    statusActive: 'Активен',
    dnsFailed: (msg: string) => `DNS не загрузились: ${msg}`,
    dnsWhere: 'Где хранятся записи',
    dnsUplink: 'Записи в Uplink',
    dnsOwnNs: 'Свои NS',
    apex: '@ (сам домен)',
    deleteRecord: (host: string) => `Удалить запись ${host}`,
    noRecords: 'Записей пока нет. Добавьте A-запись, чтобы домен открывал ваш сервер.',
    recordType: 'Тип записи',
    host: 'Имя',
    hostHint: '@ или поддомен, например www',
    priority: 'Приоритет',
    value: 'Значение',
    valueHint: {
      A: 'IPv4-адрес сервера, например 203.0.113.10',
      AAAA: 'IPv6-адрес сервера',
      CNAME: 'Имя другого хоста, например example.com',
      MX: 'Почтовый сервер, например mx.yandex.net',
      TXT: 'Текст: SPF, проверка владения и т. п.',
    },
    addRecord: 'Добавить запись',
    switchToUplink:
      'Сейчас домен смотрит на свои NS. После сохранения он перейдёт на DNS Uplink с этими записями.',
    saveRecords: 'Сохранить записи',
    moreNs: 'Ещё NS',
    nsFooter: 'Например, NS от Cloudflare или вашего хостинга. Записи в Uplink перестанут работать.',
    saveNs: 'Сохранить NS',
    transfer: 'Перенос',
    transferFooter: 'Код нужен, чтобы перенести домен к другому регистратору. Никому его не показывайте.',
    authCode: 'Код переноса',
  },

  servers: {
    title: 'Серверы',
    emptyTitle: 'Пока нет серверов',
    emptyText: (from: string | null) =>
      `Облачный сервер с root-доступом за пару минут: Европа, Америка и Азия${from ? `, от ${from} в месяц` : ''}.`,
    create: 'Создать сервер',
    createVpn: 'Свой VPN',
    regions: { europe: 'Европа', americas: 'Америка', asia: 'Азия', cis: 'СНГ' },
    state: {
      creating: 'Создаётся',
      failed: 'Создание не удалось',
      suspended: 'Остановлен за неуплату',
      deleted: 'Удалён',
      running: 'Работает',
      stopped: 'Выключен',
      reinstalling: 'Переустановка',
      blocked: 'Заблокирован',
      busy: 'Выполняется действие',
    },
    gb: 'ГБ',
    mb: 'МБ',
    disk: (gb: number) => `${gb} ГБ диск`,
  },

  serverCreate: {
    vpnUnavailable: 'Серверы под VPN сейчас недоступны. Загляните позже или напишите в поддержку',
    title: 'Новый сервер',
    purpose: 'Для чего сервер',
    purposeServer: 'Сервер',
    purposeVpn: 'Свой VPN',
    vpnWhich: 'Какой VPN поставить',
    vpnShort: 'VPN',
    vpnFooter:
      'Поставим VPN сами при первом запуске сервера и пришлём ключ. Это занимает 3–10 минут после того, как сервер готов.',
    vpnBenefitsTitle: 'Чем хорош свой VPN',
    vpnBenefits: [
      'Отдельный сервер и стабильный IP только для вас',
      'Своя панель и отдельные ключи для семьи или команды',
      'Ресурсы сервера не делят посторонние VPN-пользователи',
    ],
    trialButton: 'Протестировать VPN — 24 часа бесплатно',
    loadingPlans: 'Тарифы ещё загружаются. Загляните через пару минут.',
    where: 'Где разместить',
    whereShort: 'Где',
    region: 'Регион',
    city: 'Город',
    power: 'Мощность',
    plan: 'Конфигурация',
    allPlans: (n: number) => `Все конфигурации (${n})`,
    system: 'Система',
    vpnLaterRequiresUbuntu:
      'Если вы захотите позже установить VPN через Uplink, потребуется Ubuntu 24.04 LTS.',
    version: 'Версия',
    details: 'Детали',
    name: 'Название',
    namePlaceholder: 'Например, web или vpn',
    nameHint: 'Видно только вам',
    addSsh: 'Добавить SSH-ключ',
    ssh: 'Публичный SSH-ключ',
    sshHint: 'Содержимое ~/.ssh/id_ed25519.pub. Пароль root тоже будет в приложении',
    sshPick: 'SSH-ключ',
    sshNone: 'Без ключа',
    sshNoneHint: 'Вход по паролю root',
    sshNew: 'Новый ключ',
    sshSave: 'Сохранить ключ в профиле',
    monthly: 'В месяц',
    onBalance: 'На балансе',
    billingFooter:
      'Списывается с баланса раз в 30 дней, автопродление можно выключить. Удалить сервер можно в любой момент, остаток месяца не возвращается.',
    createFor: (price: string) => `Создать за ${price} в месяц`,
  },

  vpn: {
    title: 'VPN',
    recommended: 'лучше для РФ',
    which: 'Какой VPN',
    about: {
      vless: 'Маскируется под обычный HTTPS, стабильно работает в России. Панель 3X-UI для новых ключей',
      amneziawg: 'Быстрый WireGuard с маскировкой от блокировок. Приложение AmneziaVPN',
      outline: 'Самый простой: один ключ и приложение Outline. В России иногда блокируют',
      wireguard: 'Классический WireGuard с веб-панелью. Хорош за пределами России',
    },
    intro: 'Сделайте из этого сервера свой VPN: поставим его одной командой и дадим ключ для подключения.',
    installAutomatic: 'Установить VPN',
    getCommand: 'Получить команду установки',
    retry: 'Получить команду повторной установки',
    retryAutomatic: 'Попробовать ещё раз',
    installManually: 'Установить вручную',
    hideManual: 'Скрыть ручную установку',
    commandSteps: [
      'Подключитесь к серверу по SSH, как в инструкции выше',
      'Вставьте команду и нажмите Enter',
      'Подождите 3–10 минут: ключ появится здесь, а бот пришлёт сообщение',
    ],
    commandNote: 'Команда одноразовая и работает только для этого сервера.',
    steps: ['Сервер запускается', 'Ставим пакеты', 'Устанавливаем VPN', 'Создаём ключ'],
    installingFooter: 'Обычно 3–10 минут. Можно закрыть приложение: бот напишет, когда VPN будет готов.',
    failed: (error: string) =>
      `Не получилось установить VPN${error ? `: ${error}` : ''}. Сервер работает; установку можно повторить автоматически или вручную.`,
    failedTimeout:
      'Сервер не прислал ответ от установщика. Попробуйте автоматическую установку ещё раз или установите VPN вручную.',
    failedUnsupported:
      'На сервере установлена неподдерживаемая система. Штатная установка VPN доступна только на Ubuntu 24.04 LTS — переустановите сервер на неё.',
    reinstallForVpn: (image: string) => `Переустановить на ${image} для VPN`,
    reinstallConfirm: 'Все данные удалятся. Нажмите ещё раз',
    reinstallUnavailable:
      'Этот провайдер пока нельзя безопасно переустановить через Uplink. Создайте новый сервер с Ubuntu 24.04 LTS.',
    ready: 'готов',
    qr: 'QR-код ключа VPN',
    scanLink: 'Отсканируйте QR-код в приложении или скопируйте ключ и добавьте его из буфера обмена.',
    scanConfig: 'Отсканируйте QR-код в приложении или скопируйте конфиг и импортируйте его.',
    howTo: 'Приложения для подключения',
    clientPlatform: 'Ваше устройство',
    clientPlatforms: {
      apple: 'Apple',
      android: 'Android',
      windows: 'Windows',
      linux: 'Linux',
    },
    install: 'Установить',
    appGuideTitle: (name: string) => `Как подключить ${name}`,
    appGuideInstall: (name: string) => `1. Установите ${name}`,
    appGuideInstallHint:
      'Если приложение уже установлено, переходите к следующему шагу. Если магазин открылся внутри Telegram, выберите «⋯» → «Открыть в браузере».',
    appGuideCopy: '2. Скопируйте ключ VPN',
    appGuideCopyHint: 'Нажмите «Копировать». Ключ целиком сохранится в буфере обмена.',
    appGuideImport: (name: string) => `3. Добавьте ключ в ${name}`,
    appGuideSteps: {
      v2box: [
        'Откройте нижнюю вкладку Configs.',
        'Нажмите «+» в правом верхнем углу.',
        'Выберите Import V2Ray URI from Clipboard.',
        'Вернитесь на вкладку Home, выберите добавленное подключение и нажмите Tap to Connect.',
      ],
      v2raytun: [
        'Откройте приложение и нажмите «+».',
        'Выберите импорт конфигурации из буфера обмена.',
        'Подтвердите добавление сервера.',
        'Выберите добавленный сервер и нажмите кнопку подключения.',
      ],
      happ: [
        'Откройте приложение и нажмите «+» в правом верхнем углу.',
        'Выберите добавление конфигурации из буфера обмена или URL.',
        'Подтвердите импорт VLESS-конфигурации.',
        'Выберите добавленный сервер и включите VPN.',
      ],
      hiddify: [
        'Откройте приложение и нажмите «+» в правом верхнем углу.',
        'Выберите «Добавить из буфера обмена».',
        'Подтвердите добавление профиля.',
        'Выберите профиль и нажмите большую кнопку подключения.',
      ],
      v2rayn: [
        'Распакуйте загруженный архив и запустите v2rayN.exe.',
        'В области уведомлений Windows откройте v2rayN.',
        'Нажмите Servers → Import share links from clipboard.',
        'Выберите добавленный сервер и включите системный прокси.',
      ],
      v2raya: [
        'Установите v2rayA по инструкции для вашего дистрибутива Linux.',
        'Откройте панель v2rayA по адресу http://127.0.0.1:2017.',
        'Импортируйте скопированную VLESS-ссылку.',
        'Выберите добавленный сервер и нажмите на кнопку запуска.',
      ],
    },
    backToApps: 'Вернуться к выбору приложения',
    howToFooter: {
      vless: 'Выберите приложение, чтобы открыть подробную инструкцию по установке и подключению.',
      amneziawg: 'В AmneziaVPN нажмите «+», затем «Файл с настройками» или QR-код.',
      outline: 'Откройте Outline, нажмите «+» и вставьте ключ.',
      wireguard: 'В WireGuard нажмите «+» и выберите «Сканировать QR-код» или импорт из буфера.',
    },
    panel: 'Панель управления',
    panelFooter: {
      vless: 'Откройте адрес в браузере: в панели 3X-UI можно добавить ключи для друзей и смотреть трафик.',
      amneziawg: '',
      outline: '',
      wireguard: 'Откройте адрес в браузере: в панели wg-easy можно добавить ключи для других устройств.',
    },
    panelCertificateWarning:
      'Сертификат панели временный: при первом открытии браузер покажет предупреждение безопасности.',
    panelMissing: 'Реквизиты панели не были сохранены при установке',
    panelMissingHint:
      'VPN продолжает работать. Чтобы получить панель, нажмите «Поставить другой VPN» и снова выберите VLESS Reality.',
    login: 'Логин',
    password: 'Пароль',
    manager: 'Outline Manager',
    managerFooter:
      'Чтобы добавлять ключи, установите Outline Manager, выберите «Добавить сервер» и вставьте эту строку.',
    another: 'Поставить другой VPN',
  },

  server: {
    name: 'Название сервера',
    namePlaceholder: 'Например, VPN для семьи',
    creating: 'Создание сервера',
    stepPaid: 'Оплачено',
    stepCreate: 'Создаём сервер',
    stepInstall: (image: string) => `Устанавливаем ${image}`,
    stepVpn: 'Устанавливаем VPN',
    stepReady: 'Готов к работе',
    creatingFooter: 'Обычно 1–3 минуты. Можно закрыть приложение: бот напишет, когда сервер будет готов.',
    access: 'Доступ',
    accessFooter: 'Пароль видите только вы. Если он попал к кому-то ещё, сбросьте его.',
    monitoring: 'Мониторинг',
    monitoringIntro:
      'Графики процессора, памяти, диска и сети. Достаточно один раз выполнить команду на сервере, а если сервер перестанет отвечать, бот сразу напишет.',
    monitoringConnect: 'Подключить мониторинг',
    monitoringSteps: [
      'Подключитесь к серверу по SSH (инструкция выше).',
      'Вставьте команду и нажмите Enter.',
      'Через минуту здесь появятся графики.',
    ],
    monitoringWaiting: 'Ждём первые данные от сервера…',
    monitoringShowCommand: 'Показать команду установки',
    monitoringOnline: 'на связи',
    monitoringOffline: (when: string) => `не отвечает с ${when}`,
    monitoringRemove: 'Как отключить мониторинг',
    monitoringRemoveHint: 'Выполните на сервере, чтобы удалить агента:',
    monitoringNote: 'Агент только читает нагрузку и отправляет цифры, команды извне он не выполняет.',
    cpu: 'Процессор',
    ram: 'Память',
    disk: 'Диск',
    net: 'Сеть',
    netIn: 'вход',
    netOut: 'выход',
    ranges: { '1h': '1 час', '24h': '24 часа', '7d': '7 дней' },
    bytes: ['Б', 'КБ', 'МБ', 'ГБ', 'ТБ'],
    perSecond: '/с',
    readyTitle: 'Сервер готов',
    readyText: 'Подключитесь по SSH: команда и пароль ниже, а пошаговая инструкция — под ними.',
    failedTitle: 'Создание не удалось',
    failedText: 'Провайдер не создал сервер. Ниже указана полученная от него причина.',
    refunded: 'Деньги полностью вернулись на ваш баланс.',
    guide: 'Как подключиться',
    guideFooter: 'Пароль при вводе не отображается, так и должно быть. Вставьте его и нажмите Enter.',
    guideOs: { windows: 'Windows', mac: 'macOS', linux: 'Linux', phone: 'Телефон' },
    guideSteps: {
      windows: [
        'Нажмите Win + X и выберите «Терминал» или «PowerShell».',
        'Вставьте команду подключения и нажмите Enter.',
        'На вопрос «Are you sure you want to continue connecting» напишите yes.',
        'Вставьте пароль root и нажмите Enter.',
      ],
      mac: [
        'Нажмите Cmd + Пробел, введите «Терминал» и откройте его.',
        'Вставьте команду подключения и нажмите Enter.',
        'На вопрос «Are you sure you want to continue connecting» напишите yes.',
        'Вставьте пароль root и нажмите Enter.',
      ],
      linux: [
        'Откройте терминал (обычно Ctrl + Alt + T).',
        'Вставьте команду подключения и нажмите Enter.',
        'На вопрос «Are you sure you want to continue connecting» напишите yes.',
        'Вставьте пароль root и нажмите Enter.',
      ],
      phone: [
        'Установите бесплатное приложение Termius из App Store или Google Play.',
        'Создайте новый хост: адрес — IP сервера, пользователь — root.',
        'Вставьте пароль root и подключитесь.',
      ],
    },
    connect: 'Подключение',
    user: 'Пользователь',
    rootPassword: 'Пароль root',
    resetPassword: 'Сбросить пароль',
    passwordReset: 'Новый пароль готов, нажмите «Показать»',
    power: 'Питание',
    reboot: 'Перезагрузить',
    start: 'Включить',
    shutdown: 'Выключить',
    billing: 'Оплата',
    suspendedFooter:
      'Сервер остановлен, данные пока сохранены. Оплатите месяц в течение 3 дней, иначе сервер будет удалён.',
    autoFooter: 'Продлим с баланса в день окончания. Бот напомнит за 3 и 1 день, если денег не хватает.',
    manualFooter: 'Автопродление выключено: продлите вручную, иначе сервер остановится.',
    paidUntil: 'Оплачен до',
    perMonth: (price: string) => `${price} в месяц`,
    renewShort: (amount: string) => `Для продления пополните баланс на ${amount}`,
    renewFor: (price: string) => `Продлить на месяц за ${price}`,
    reinstall: 'Переустановить систему',
    reinstallTo: (image: string) => `Переустановить на ${image}`,
    reinstallConfirm: 'Все данные удалятся. Нажмите ещё раз',
    danger: 'Удаление',
    delete: 'Удалить сервер',
    deleteConfirm: 'Сервер и данные удалятся навсегда. Нажмите ещё раз',
    deleteFooter: 'Остаток оплаченного месяца не возвращается.',
    payAndStart: (price: string) => `Оплатить ${price} и запустить`,
  },

  balance: {
    title: 'Баланс',
    emptyTitle: 'Операций пока нет',
    emptyText: 'Пополнения и списания за услуги появятся здесь.',
    history: 'История',
    inUsd: (usd: string) => `${usd} на счёте`,
    promo: 'Промокод',
    promoRow: 'Ввести промокод',
    promoPlaceholder: 'Например, WELCOME',
    promoApply: 'Активировать',
    promoDone: (amount: string) => `Промокод активирован: +${amount} на баланс`,
    runwayUntil: (date: string) => `до ${date}`,
    runwayYear: 'больше года',
  },

  topup: {
    title: 'Пополнение',
    amount: 'Сумма',
    range: (min: string, max: string) => `Сумма от ${min} до ${max}`,
    payment: 'Способ оплаты',
    footer: (amount: string | null, via: string) =>
      `Счёт в ${via} действует 30 минут. Сумму в крипте ${via} посчитает по текущему курсу, на баланс придёт ровно ${amount ?? 'указанная сумма'}.`,
    credit: 'Зачислим на баланс',
    approx: (value: string) => `≈ ${value}`,
    pay: (amount: string, via: string) => `Оплатить ${amount} в ${via}`,
    enterAmount: 'Введите сумму',
    paid: (asset: string | null) => `Баланс пополнен${asset ? `, оплата в ${asset}` : ''}`,
    backToOrder: 'Вернуться к заказу',
    expired: 'Счёт истёк',
    waiting: (via: string) => `Ждём оплату в ${via}`,
    expiredText: 'Создайте новый счёт. Если вы уже оплатили, деньги всё равно придут на баланс.',
    waitingText: (amount: string) =>
      `Оплатите ${amount} в открывшемся окне. Баланс обновится сам, бот тоже пришлёт сообщение.`,
    newInvoice: 'Создать новый счёт',
    reopen: 'Открыть счёт ещё раз',
    firstBonus: (pct: number, max: string) => `+${pct}% к первому пополнению, до ${max}`,
    resuming: (what: string) => `Оформляем: ${what}`,
    resumingText: 'Баланс пополнен, заказ оформляется сам.',
    resumeFailed: 'Баланс пополнен, но заказ не оформился. Вернитесь к нему и попробуйте ещё раз.',
  },

  gift: {
    title: 'Подарок',
    what: 'Что подарить',
    amount: 'Сумму',
    domain: 'Домен',
    domainLabel: 'Домен для друга',
    domainHint: 'Найдём свободный домен и его цену на первый год',
    domainFree: (price: string) => `Свободен, ${price} за первый год`,
    domainTaken: 'Уже занят, попробуйте другой',
    message: 'Пожелание',
    messagePlaceholder: 'С днём рождения! Пусть сайт взлетит',
    footer:
      'Деньги спишутся с баланса и придут другу, когда он откроет ссылку. Пока подарок не забрали, его можно отменить.',
    give: (amount: string) => `Подарить за ${amount}`,
    pick: 'Выберите сумму или домен',
    short: (amount: string) => `Пополнить на ${amount}`,
    ready: 'Подарок готов',
    readyText: 'Отправьте ссылку другу: забрать подарок можно один раз.',
    share: 'Отправить другу',
    shareText: 'Тебе подарок в Uplink 🎁',
    sent: 'Отправленные',
    statusActive: 'ждёт',
    statusClaimed: (name: string | null) => (name ? `забрал(а) ${name}` : 'забрали'),
    statusCancelled: 'отменён',
    cancel: 'Отменить',
    another: 'Подарить ещё',
  },

  desk: {
    subtitle: 'Баланс, серверы и домены в одном месте',
    history: 'История',
    topUp: 'Пополнить',
    balance: 'Баланс',
    monthly: 'Расход в месяц',
    runway: 'Хватит',
    create: 'Создать',
    vpnSub: 'Ключ и QR-код за 5–10 минут',
    gift: 'Подарок',
    giftSub: 'Сумма или домен другу',
    noServers: 'Серверов пока нет. Создайте первый: он будет готов через пару минут.',
    noDomains: 'Доменов пока нет. Найдите имя и купите его за минуту.',
    findDomain: 'Найти домен',
    autoOn: 'автопродление',
    autoOff: 'вручную',
    signOut: 'Выйти',
  },

  web: {
    sections: 'Разделы',
    openTelegram: 'Открыть в Telegram',
    linkTelegram: 'Привязать Telegram',
    linkingTelegram: 'Подтвердите в Telegram…',
    telegramLinked: (username: string | null) => (username ? `Telegram · @${username}` : 'Telegram привязан'),
    telegramNotLinked: 'Telegram не привязан',
  },

  account: {
    title: 'Аккаунт',
    confirmed: 'подтверждён',
    unconfirmed: 'Email не подтверждён',
    resend: 'Ещё раз',
    sent: 'Отправлено',
    webSignIn: 'Вход на сайте',
    webSignInText: 'Email и пароль для uplinkcloud.io',
    webFooter: 'Задайте email и пароль, чтобы пользоваться тем же аккаунтом в браузере.',
    telegramFooter:
      'Привяжите Telegram: откроется бот, подтвердите кнопкой. Если в Telegram уже был аккаунт Uplink, баланс, домены и серверы объединятся.',
    password: 'Сменить пароль',
    telegram: 'Telegram',
    linked: 'привязан',
    linkTelegram: 'Привязать Telegram',
    linkWaiting: 'Подтвердите привязку в боте…',
    email: 'Email',
    currentPassword: 'Текущий пароль',
    newPassword: 'Новый пароль',
    passwordHint: 'Не короче 8 символов',
    save: 'Сохранить',
    signOut: 'Выйти',
  },

  profile: {
    title: 'Профиль',
    settings: 'Настройки',
    language: 'Язык',
    currency: 'Валюта',
    theme: 'Тема',
    themeAuto: 'Авто',
    themeLight: 'Светлая',
    themeDark: 'Тёмная',
    currencyFooter: 'Баланс, пополнения и списания ведутся в долларах. Рубли и евро показываем по курсу ЦБ.',
    noRates: 'Курс сейчас недоступен, цены показаны в долларах.',
    support: 'Поддержка',
    supportRow: 'Написать в поддержку',
    supportFooter: 'Напишите боту в чат, оператор ответит там же.',
    invite: 'Пригласить друзей',
    inviteTitle: (pct: number) => `${pct}% с каждого пополнения друга`,
    inviteTitleNoReward: 'Ваша ссылка',
    inviteText:
      'Друг заходит по вашей ссылке, и вам на баланс приходит процент от каждого его пополнения. Навсегда.',
    inviteShare: 'Поделиться',
    inviteShareText: 'Домены и серверы прямо в Telegram, с оплатой криптой',
    invited: 'Пригласили',
    earned: 'Заработали',
    giftRow: 'Подарить домен или сумму',
    sshKeys: 'SSH-ключи',
    sshKeysFooter: 'Сохранённые ключи можно выбрать при создании сервера, вставлять заново не придётся.',
    sshAdd: 'Добавить ключ',
    sshAddDone: 'Ключ сохранён',
    sshDelete: 'Удалить',
    sshPlaceholder: 'ssh-ed25519 AAAA… user@laptop',
  },
};

export type Messages = typeof ru;

/** Russian plural: 1 день, 2 дня, 5 дней */
export function plural(n: number, one: string, few: string, many: string) {
  const m10 = n % 10;
  const m100 = n % 100;
  if (m10 === 1 && m100 !== 11) return one;
  if (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) return few;
  return many;
}
